<template>
  <div class="h100vh-116">
  <div class="h100vh-140">
    <ejs-grid ref='grid' :dataSource="data" :allowResizing='true' :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :actionComplete='actionComplete' :allowPaging='true' :pageSettings="page" height="calc(100% - 0px)">
      <e-columns>
        <e-column type='checkbox' headerText='grpnum' width='30' textAlign='Center'></e-column>
        <e-column field='grpnum' :headerText="$t('SubscriberIms.groupNo')" width='150' textAlign='Center'></e-column>
        <e-column field='grpname' :headerText="$t('SubscriberIms.groupName')" width='150' textAlign='Center'></e-column>
        <e-column field='grptype' :headerText="$t('SubscriberIms.groupType')" width='150' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter='grptypeFormat'></e-column>
        <e-column field='grpproperty' :headerText="$t('SubscriberIms.grpproperty')" width='150' textAlign='Center' :formatter='grppropertyFormat'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref="grpPager" @click='getGridData(node, false)' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount'></ejs-pager>
  </div>
  <CustomDialog ref='addGroupPage' :element='dialog.element.eleAddImsGroup' :styles='dialog.styles' :messages='dialog.messages.addGroup'>
    <template v-slot:dialog-content>
      <AddImsGroupDialog ref='addGroup' :opCode="opCode"></AddImsGroupDialog>
    </template>
  </CustomDialog>
    <CustomDialog ref='modGroupPage' :element='dialog.element.eleModImsGroup' :styles='dialog.styles' :messages='dialog.messages.modGroup'>
      <template v-slot:dialog-content>
        <AddImsGroupDialog ref='modGroup' :opCode="opCode" :node="node"></AddImsGroupDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='addGroupMemberPage' :element='dialog.element.eleAddImsGroupMember' :styles='dialog.stylesGroupList' :messages='dialog.messages.addGroupMember'>
      <template v-slot:dialog-content>
        <AddGroupMemberDialog ref='addGroupMember' opCode='addMember' :msgid="taskMsgid.addGroupMemberMsgid" :neid="info.neid" :node="node" :neversion="info.neversion"></AddGroupMemberDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='modGroupMemberPage' :element='dialog.element.eleModImsGroupMember' :styles='dialog.stylesMemeberList' :node="node" :messages='dialog.messages.qryGroupMember'>
      <template v-slot:dialog-content>
        <QryGroupMemberDialog ref='modGroupMember' :msgid="taskMsgid.modGroupMemberMsgid" :neid="info.neid" :node="node" opCode="mod" :neversion="info.neversion"></QryGroupMemberDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='qryImsGroupPage' :element='dialog.element.eleQryImsGroup' :styles='dialog.stylesSearch' :messages='dialog.messages.search'>
      <template v-slot:dialog-content>
        <ImsGroupSearchDialog ref='qryImsGroup'></ImsGroupSearchDialog>
      </template>
    </CustomDialog>
    <div class="h-system-hide-upload">
      <ejs-uploader
        autoUpload="false"
        allowedExtensions=".xls,.xlsx"
        :multiple="false"
        id="file"
        :selected="onFileSelect"
        ref="importGroup"
      ></ejs-uploader>
    </div>
    <LayerDialog ref='layerDialog' :element='dialog.element.layerTip'>
    </LayerDialog>
    <CustomDialog ref='dialogListPage' :element='dialog.element.eleDialogList' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialogList'></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { Resize } from '@syncfusion/ej2-vue-grids';
import XLSX from 'xlsx';
import CustomDialog from '../../../common/CustomDialog';
import AddImsGroupDialog from './dialog/AddImsGroupDialog';
import AddGroupMemberDialog from './dialog/AddGroupMemberDialog';
import QryGroupMemberDialog from './dialog/QryGroupMemberDialog';
import LayerDialog from '../LayerDialog';
import DialogList from '../../util/tipDialog/DialogList';
import ImsGroupSearchDialog from './dialog/ImsGroupSearchDialog';
import { EventBus } from '../../../../plugins/eventBus';

export default {
  name: 'ImsGroupTable',
  components: {
    DialogList,
    CustomDialog,
    AddImsGroupDialog,
    AddGroupMemberDialog,
    QryGroupMemberDialog,
    LayerDialog,
    ImsGroupSearchDialog,
    EventBus
    // XLSX,
  },
  provide: {
    grid: [Resize]
  },
  data() {
    return {
      POC_VERSION_22: 'V22',
      node: '',
      opCodeKey: '',
      opCode: '',
      opCodeMap: {
        'add': 0,
        'mod': 1,
        'batchMod': 2,
        'batchAdd': 3,
      },
      data: {},
      dialPlanMap: {
        4: 'DIAL_PLAN_DMR',
        5: ['DIAL_PLAN_CPS_P3', 'DIAL_PLAN_CPSX_P3'],
        6: 'DIAL_PLAN_ZJ',
      },
      clickFlag: false,
      groupnumList: [],
      neidAndDialplanMap: new Map(),
      qrySearchBak: null,
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      info: {
        msgid: '',
        neid: '',
        netype: 'p_hss',
        neversion: '',
      },
      zoneVo: {
        neid: '',
        moname: 'TcfDialPlanCfg',
        name: 'DialPlan'
      },
      dialPlanList: [4, 5, 6], // 网管只支持p3\dmr\浙江拨号方案
      dialPlan: '',
      taskMsgid: {
        addGroupMsgid: '27823', // 添加组命令码
        modGroupMsgid: '27824', // 修改组命令吗
        delGroupMsgid: '27825', // 删除组命令码
        qryGroupMsgid: '27826', // 查询组命令吗
        addGroupMemberMsgid: '27828', // 添加隶属关系命令码
        modGroupMemberMsgid: '27829', // 修改隶属关系命令吗
        delGroupMemberMsgid: '27830', // 删除隶属关系命令码
        qryGroupMemberMsgid: '27831', // 查询隶属关系命令吗
        qryUserListMsgid: '27836',
        qryGrpServiceMsgid: '27821'
      },
      logParamInfo: {
        // module: 'subscriber.imsGroup',
        module: 'res.subscriber#res.subscriber_ims#subscriber.imsGroup',
        execFunName: ['subscriber.addGroup', 'subscriber.modGroup', 'subscriber.delGroup', 'subscriber.addGroupMember', 'subscriber.modGroupMember', 'subscriber.delroupMember']
      },
      vo: {
        flag: '',
      },
      batchModRes: [],
      xlsxJson: [],
      fileList: [],
      dataForm: [],
      wb: null,
      chooseCount: 0,
      dialog: {
        tipInfos: '',
        styles: {
          width: '810px',
          height: '760px',
          visible: false,
          model: true,
          zIndex: 1000
        },
        stylesGroupList: {
          width: '65%',
          height: '78%',
          visible: false,
          model: true
        },
        stylesMemeberList: {
          width: '65%',
          height: '78%',
          visible: false,
          model: true,
        },
        stylesImport: {
          width: '26%',
          height: '30%',
          visible: false,
          model: true
        },
        stylesSearch: {
          width: '20%',
          height: '38%',
          visible: false,
          model: true
        },
        stylesLayerTip: {
          width: '20%',
          height: '25%',
          visible: false,
          model: true
        },
        element: {
          eleAddImsGroup: {
            target: this.$refs.grouptable,
            refName: 'addGroup',
            buttonGroup: [
              {
                click: this.closeAddImsGroupPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.saveAddImsGroupPage, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
              },
            ],
            title: this.$t('SubscriberIms.addGroup'),
            isClose: true
          },
          eleModImsGroup: {
            target: this.$refs.grouptable,
            refName: 'modGroup',
            buttonGroup: [
              {
                click: this.closeModImsGroupPage,
                buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.saveModImsGroupPage, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
              }
            ],
            title: this.$t('SubscriberIms.modGroup'),
            isClose: true
          },
          eleAddImsGroupMember: {
            target: this.$refs.grouptable,
            refName: 'addGroupMember',
            buttonGroup: [
              {
                click: this.closeAddImsGroupMemberPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.saveAddImsGroupMemberPage, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
              }
            ],
            title: this.$t('SubscriberIms.addUserMember'),
            isClose: true
          },
          eleModImsGroupMember: {
            target: this.$refs.grouptable,
            refName: 'modGroupMember',
            buttonGroup: [
              {
                click: this.closeModImsGroupMemberPage,
                buttonModel: {
                  content: this.$t('SubscriberIms.close'),
                  isPrimary: true
                }
              }
            ],
            title: this.$t('SubscriberIms.controlMember'),
            isClose: true
          },
          eleImsSearch: {
            target: this.$refs.grouptable,
            refName: 'search',
            buttonGroup: [
              {
                buttonModel: {
                  content: this.$t('SubscriberIms.confirm'),
                  isPrimary: true
                }
              },
              {
                click: this.closeQryImsGroupMemberPage,
                buttonModel: { content: this.$t('SubscriberIms.cancel') }
              }
            ],
            title: this.$t('SubscriberIms.find'),
            isClose: true
          },
          eleImportGroupPage: {
            target: this.$refs.grouptable,
            refName: 'importGroup',
            buttonGroup: [
              {
                click: this.closeAddImsGroupMemberPage,
                buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                buttonModel: {
                  content: this.$t('SubscriberIms.confirm'),
                  isPrimary: true
                }
              }
            ],
            title: this.$t('SubscriberIms.import'),
            isClose: true
          },
          layerTip: {
            target: this.$refs.grouptable,
            refName: 'layerDialog',
            buttonGroup: [
              {
                click: this.closeLayerTipPage,
                buttonModel: { content: this.$t('SubscriberIms.confirm') }
              }
            ],
            title: this.$t('SubscriberIms.warn'),
            isClose: true,
          },
          eleDialogList: {
            target: this.$refs.grouptable,
            refName: 'dialogList',
            buttonGroup: [
              {
                click: this.closeDialogListTipPage,
                buttonModel: { content: this.$t('SubscriberIms.confirm') }
              }
            ],
            title: this.$t('SubscriberIms.logTitle'),
            isClose: true,
          },
          eleQryImsGroup: {
            target: this.$refs.grouptable,
            refName: 'qryImsGroup',
            buttonGroup: [
              {
                click: this.closeQryImsGroupPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
              },
              {
                click: this.qryImsGroupPage, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
              }
            ],
            title: this.$t('SubscriberIms.qryAdvance'),
            isClose: true
          },
        },
        messages: {
          addGroup: {
            title: this.$t('SubscriberIms.addGroup')
          },
          modGroup: {
            title: this.$t('SubscriberIms.modGroup')
          },
          addGroupMember: {
            title: this.$t('SubscriberIms.addUserMember')
          },
          qryGroupMember: {
            title: this.$t('SubscriberIms.qryUserMember')
          },
          search: {
            title: this.$t('SubscriberIms.qryAdvance')
          },
          importGroup: {
            title: this.$t('SubscriberIms.import'),
          },
        },
      },
      gridTypeEnum: {
        grpType: [this.$t('SubscriberIms.grptype0'), this.$t('SubscriberIms.grptype1'), this.$t('SubscriberIms.grptype2'), this.$t('SubscriberIms.grptype3'), this.$t('SubscriberIms.grptype4')],
        grpproperty: [this.$t('SubscriberIms.grpproperty0'), this.$t('SubscriberIms.grpproperty1')],
      }
    };
  },
  methods: {
    grptypeFormat(grids, data) {
      return this.gridTypeEnum.grpType[data.grptype];
    },
    grppropertyFormat(grids, data) {
      return this.gridTypeEnum.grpproperty[data.grpproperty];
    },
    clearGridData() {
      const $this = this;
      $this.data = [];
      $this.page.pageCount = 0;
      $this.page.totalCount = 0;
      $this.page.pageCount = 0;
      $this.info.neid = '';
      $this.info.vpnid = '';
      $this.info.vpnname = '';
    },
    actionComplete() {
      this.$refs.grid.selectRow(0, true);
      this.$refs.grid.selectRow(0, true);
    },
    // node 左侧的组织架构节点
    getGridData(node, isFirstPage = true) {
      const $this = this;
      $this.node = node;

      if ($this.node !== '' && typeof $this.node !== 'undefined') {

        const array    = $this.node.id.split('_');
        const neid     = array[0];
        const vpnid    = array[2];
        const vpnclass = parseInt($this.node.level, 0) - 1;

        $this.neids    = [];
        $this.neids.push(neid);

        $this.info.neid      = neid;
        $this.info.neversion = $this.node.neNode.softwareVersion;
        $this.info.vpnid     = vpnid;
        $this.info.vpnClass  = vpnclass;
        $this.vo.vpnid       = vpnid;
        $this.vo.vpnClass    = vpnclass;
        $this.vo.flag        = 0;
        $this.vo.vpnname     = $this.node.text;
        $this.page.pageNo    = isFirstPage ? 1 : $this.$refs.grpPager.ej2Instances.currentPage;

        const paramTotal = {
          vo: {
            ...$this.vo,
            ...$this.qrySearchBak,
          },
          info: {
            msgid: $this.taskMsgid.qryGroupMsgid,
            neid: $this.info.neid
          },
          page: $this.page
        };

        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramTotal).then((response) => {
          if (response.data.errorCode !== '0') {
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
          } else {
            const res = response.data.resultVal;
            $this.data = res.resultList;
            // $this.page.pageNo = res.page;
            $this.page.totalCount = res.countrsp;
            // 临时解决6361单：组数据都删除，再添加，无法选中全选框
            setTimeout(()=> {
              if (res.countrsp === 0) { // 没有数据---组件会将domtokenlist增加e-checkbox-disabled属性
                const temp = $this.$refs.grid.$el.childNodes[2].children[0].children[0].children[1].children[0].children[0].children[0].children[0].classList;
                if (temp.length > 2) {
                  temp.remove('e-checkbox-disabled');
                }
              }
            }, 100);
            // $this.page.pageCount = Math.ceil(res.countrsp / $this.page.pageSize);
          }
        });
      } else {
        $this.info.neid = '';
        $this.vo.vpnid = '';
        $this.vo.vpnname = '';
      }
    },
    isChooseNeWithCall(callFun, opCode) {
      if (typeof (this.vo.vpnid) === 'undefined' || this.vo.vpnid === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.checkVpnTip') });
        return;
      }
      this.checkNeStatus(callFun, opCode);
    },
    isChooseNe() {
      if (typeof (this.vo.vpnid) === 'undefined' || this.vo.vpnid === '') {
        // this.dialog.tipInfos = this.$t('SubscriberIms.checkVpnTip');
        // this.$refs.layerDialog.show(this.dialog.tipInfos);
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.checkVpnTip') });
        return false;
      }
      return true;
    },
    getParams(pageInfo) {
      const $this = this;
      let qryParams = null;
      qryParams = {
        page: typeof pageInfo === 'undefined' ? null : pageInfo,
        info: $this.info,
        vo: $this.vo
      };
      return qryParams;
    },

    getCheckedData(selectOnly, type) {
      let selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        this.dialog.tipInfos = this.$t('SubscriberIms.noCheckDataTip');
        EventBus.$emit('toast', { type: 'warning', content: this.dialog.tipInfos });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        this.dialog.tipInfos = this.$t('SubscriberIms.checkDataMoreTip');
        EventBus.$emit('toast', { type: 'warning', content: this.dialog.tipInfos });
        return false;
      }
      if (selectOnly && selectedRecords.length === 1 && type) {
        this.dialog.tipInfos = this.$t('SubscriberIms.checkDateLessTip');
        EventBus.$emit('toast', { type: 'warning', content: this.dialog.tipInfos });
        return false;
      }
      if (type && selectOnly) { // 多选 并判断类型
        const tempSelectData = selectedRecords[0][type];
        try {
          selectedRecords.forEach(item => {
            console.log(tempSelectData, item[type]);
            if (item[type] !== tempSelectData) {
              this.dialog.tipInfos = this.$t('SubscriberIms.notModWithDifTypeTip');
              EventBus.$emit('toast', { type: 'warning', content: this.dialog.tipInfos });
              selectedRecords = [];
              throw new Error('ending');
            }
          });
        } catch (e) { }
      }
      return selectedRecords;
    },

    getCheckedVals(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      // const grpnum = [];
      const checkedData = this.getCheckedData(selectOnly);
      // for (let i = 0; i < checkedData.length; i++) {
      //   grpnum.push(checkedData[i].grpnum);
      // }
      return checkedData.length === 0 ? false : checkedData;
    },
    // 同种组类型支持多选
    getCheckedValsWithType(selectOnly = false, type = false) {
      // x-> false: 不支持多选   true: 支持多选
      // type-> 组类型
      // const grpnum = [];
      const checkedData = this.getCheckedData(selectOnly, type);
      // for (let i = 0; i < checkedData.length; i++) {
      //   grpnum.push(checkedData[i].grpnum);
      // }
      return checkedData.length === 0 ? false : checkedData;
    },

    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    getParamsForNewPage(opCode) {
      const params = {};
      params.dialPlan = this.dialPlan;
      params.neid = this.info.neid;
      params.neversion = this.info.neversion;
      params.vpnid = this.info.vpnid;
      params.vpnname = this.vo.vpnname;
      params.opCode = opCode;
      params.showFlag = this.poc22Flag;
      this.opCodeKey = this.opCodeMap[opCode];
      return params;
    },
    getGrpNumByDialplan(item, type) { // type=1，添加；type=2,批量添加
      // 根据拨号方案及组类型设置组号码
      // 当前版本号码与组类型切换无关联
      // 区号是否为空
      if (item['grpnum[zone]'] === '' || item['grpnum[zone]'] === undefined) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.checkZoneTip') });
        return false;
      }
      // 起始号码范围判断
      if (type === 'batchAdd') {
        if (parseInt(item['grpnum[startNo]'], 0) > parseInt(item['grpnum[endNo]'], 0)) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.endNOLessStartNo') });
          return false;
        }
        if ((parseInt(item['grpnum[endNo]'], 0) - parseInt(item['grpnum[startNo]'], 0)) > 1000) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.groupNumLimitTip') });
          return false;
        }
      }
      let groupNumMin = 0;
      let groupNumMax = 0;
      if (this.dialPlan === this.dialPlanList[1] || this.dialPlan === this.dialPlanList[2]) { // p3拨号方案\浙江拨号方案
        // 区号+队号+个号
        if (type === 'add') {
          groupNumMin = `${item['grpnum[zone]']}${item['grpnum[fleet]']}${item['grpnum[number]']}`;
        } else if (type === 'batchAdd') {
          groupNumMin = `${item['grpnum[zone]']}${item['grpnum[fleet]']}${item['grpnum[startNo]']}`;
          groupNumMax = `${item['grpnum[zone]']}${item['grpnum[fleet]']}${item['grpnum[endNo]']}`;
        }
      } else if (this.dialPlan === this.dialPlanList[0]) { // dmr拨号方案
        // 区号+个号--- 个号补0
        if (type === 'add') {
          const number = this.addZero(item['grpnum[number]'], 5);
          // groupNumMin = `${item['grpnum[zone]']}${item['grpnum[number]']}`;
          groupNumMin = `${item['grpnum[zone]']}${number}`;
        } else if (type === 'batchAdd') {
          const numberMin = this.addZero(item['grpnum[startNo]'], 5);
          const numberMax = this.addZero(item['grpnum[endNo]'], 5);
          // groupNumMin = `${item['grpnum[zone]']}${item['grpnum[startNo]']}`;
          // groupNumMax = `${item['grpnum[zone]']}${item['grpnum[endNo]']}`;
          groupNumMin = `${item['grpnum[zone]']}${numberMin}`;
          groupNumMax = `${item['grpnum[zone]']}${numberMax}`;
        }
        if (groupNumMin.length > 7) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.notFitDialPlan') });
          return false;
        }
      }
      if (!(groupNumMax === 0 || groupNumMin === 0)) {
        item.opCount = groupNumMax - groupNumMin + 1;
      } else {
        item.opCount = 1;
      }
      item.grpnum = groupNumMin;
      item.bitmask = this.dialPlan;
      if (item['grpidentity[startIdentity]'] && item['grpidentity[startIdentity]'] && type === 'batchAdd') {
        const grpnumNums = item.opCount;
        const startIdentity = parseInt(item['grpidentity[startIdentity]'],10);
        const endIdentity = parseInt(item['grpidentity[endIdentity]'], 10);
        if (endIdentity - startIdentity < 0) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.lte_hss_group_groupIdentityCompare') });
          return false;
        }
        const grpidNums = endIdentity - startIdentity + 1;//组标识号的数量
        if(grpnumNums!==grpidNums){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.lte_ems_subscriber_groupMatchError') });
          return false;
        }
        item['grpidentity'] = item['grpidentity[startIdentity]'];
      }
      if (item['grpidentity[grpidentity]'] && type !== 'batchAdd') {
        item['grpidentity'] = item['grpidentity[grpidentity]'];
      }
      return item;
    },
    addZero(value, len) {
      while (value.length < len) { // 需要前面补0
        value = `0${value}`;
      }
      return value;
    },
    checkResponse(response) {
      if (response.data.errorCode !== 'SUCCESS') {
        EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        return false;
      }
      return true;
    },

    /**
     * 打开/关闭/保存  添加群组页面
     */
    openAddImsGroupPage(opCode) {
      this.isChooseNeWithCall(this.openAddImsGroupPageCall, opCode);
    },
    openAddImsGroupPageCall(opCode) {
      this.opCode = opCode;
      // 先判断拨号方案--存在则继续操作；不存在则给出提示
      // cmd: "QRY TcfDialPlanCfg : ne = 2222 ;"
      const infoMap = {};
      const info = {};
      info.neid = this.info.neid;
      info.operation = 'getDialplan';
      const voMap = {};
      voMap['0'] = this.info.neid;
      voMap['1'] = this.zoneVo.moname;
      voMap['2'] = this.zoneVo.name;
      infoMap.vo = voMap;
      infoMap.info = info;
      const param = {};
      param.neid = this.info.neid;
      param.moName = this.zoneVo.moname;
      // this.$axios.post('/lte/ems/config/mml/qryAllByNeIdAndMoName', param).then((response) => {
      if (this.neidAndDialplanMap.size > 0 && this.neidAndDialplanMap.get(this.info.neid)) {
        this.dialPlanExistThenDo(opCode);
        return;
      }
      const qryDialPlan = {};
      qryDialPlan.vo = { 0: { neid: this.info.neid, moName: this.zoneVo.moname, name: this.zoneVo.name } };
      qryDialPlan.info = info;
      this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', infoMap).then((response) => {
        if (response.status !== 200) {
          this.$refs.addGroupPage.showTemplate = false;
          this.$refs.addGroupPage.clear();
          this.$refs.addGroupPage.close();
          // this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
        } else {
          // 获取拨号方案成功---网管只支p3-5、dmr=4、浙江拨号方案=6
          let dialPlanFlag = false;
          if (response.data === '' || response.data.errorCode !== '0') {
            // this.$layer.alert({ msg: this.$t('SubscriberIms.qryDialPlanFailTip') });
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.qryDialPlanFailTip') });
            return;
          }
          if (response.data.resultVal && response.data.resultVal.length === 0) {
            // this.$layer.alert({ msg: this.$t('SubscriberIms.noDialTip') });
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.noDialTip') });
            return;
          }
          const dialP = JSON.parse(response.data.resultVal);
          const tempMap = this.dialPlanMap;
          if (this.info.neversion.includes(this.POC_VERSION_22)) {
            this.poc22Flag = true;
          } else {
            this.poc22Flag = false;
          }
          this.dialPlanList.filter((item) => {
            if (tempMap[item] instanceof Array) {
              if (tempMap[item].includes(dialP[0])) {
                dialPlanFlag = true;
                this.dialPlan = parseInt(item, 0);
              }
            } else {
              if (dialP[0] === tempMap[item]) {
                dialPlanFlag = true;
                this.dialPlan = parseInt(item, 0);
              }
            }
          });
          //2.2版本--不支持浙江拨号方案
          if (this.poc22Flag && this.dialPlan === 6) {
            dialPlanFlag = false;
          }
          if (dialPlanFlag) {
            this.neidAndDialplanMap.set(this.info.neid, this.dialPlan);
            this.dialPlanExistThenDo(opCode);
          } else {
            // this.$layer.alert({ msg: this.$t('SubscriberIms.notSuppoDialTip') });
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.notSuppoDialTip') });
            return false;
          }
        }
      });
    },
    dialPlanExistThenDo(opCode) {
      const param = { msgid: this.taskMsgid.addGroupMsgid, neid: this.info.neid };
      this.$axios.post('/lte/ems/subscriber/imsunms/getParamJson', param).then((res) => {
        if (res.status !== 200) {
          this.$refs.addGroupPage.clear();
          this.$refs.addGroupPage.close();
          // this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
        } else if (res.data.errorCode !== '0') {
          this.$refs.addGroupPage.clear();
          this.$refs.addGroupPage.close();
          EventBus.$emit('toast', { type: 'warning', content: res.data.errorString });
        } else {
          this.$refs.addGroup.mainHandler([], this.getParamsForNewPage(opCode), res);
          this.$refs.addGroupPage.show();
        }
      });
    },
    checkVpnid(vodata) {
      if (vodata.vpnid === '' || vodata.vpnid === 0) {
        vodata.vpnid = null;
      }
      return vodata;
    },
    closeAddImsGroupPage() {
      this.$refs.addGroup.clearTemplate();
      this.$refs.addGroupPage.clear();
      this.$refs.addGroupPage.close();
    },
    saveAddImsGroupPage() {
      const paramMap = {};
      let vodata = this.$refs.addGroup.getDatas();
      if (!vodata) {
        return;
      }
      vodata = this.getGrpNumByDialplan(vodata, this.opCode);
      if (!vodata) {
        return;
      }
      vodata = this.checkVpnid(vodata);
      if (this.opCode === 'add') {
        vodata.tgrpprofileid = vodata.grpnum;
      }
      const logParam = {
        module: this.logParamInfo.module, // iMS群组管理
        execFunName: this.logParamInfo.execFunName[0], // 开组
        exectype: 1,
        execData: [vodata],
      };
      paramMap.vo = vodata;
      this.info.msgid = this.taskMsgid.addGroupMsgid;
      // paramMap.set('info', this.info);
      paramMap.info = this.info;
      paramMap.log = logParam;
      console.log('paramMap=', paramMap);
      this.$loading.showLoadding(this.$t('MML.loadingTip'));
      this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramMap,{timeout: 1000 * 60 * 31}).then((response) => {
        this.$loading.hideLoadding();
        if (response.status === 200) {
          if (this.opCode === 'add') {
            this.commonHandlerResponse(response, 'addGroupPage');
          } else if (this.opCode === 'batchAdd') {
            this.$refs.addGroupPage.clear();
            this.$refs.addGroupPage.close();
            this.$refs.dialogListPage.show();
            const _showData = [];
            for (let count = 0; count < vodata.opCount; count++) {
              if(this.dialPlan == this.dialPlanList[0]) {
                _showData[count] = { operObj: this.addZero(parseInt(vodata.grpnum, 0) + count+'', 7) };
              } else{
                _showData[count] = { operObj: parseInt(vodata.grpnum, 0) + count };
              }
            }
            response.data.resultVal.forEach((item, index) => {
              _showData[index].operResult = item.display;
              _showData[index].operCode = item.code;
            });
            this.$refs.dialogList.addOperetionResultList(_showData);
            this.getGridData(this.node);
          }
        } else {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
        }
      });
    },
    commonHandlerResponse(response, closePage) {
      if (response.data.resultVal && response.data.resultVal.length > 0) {
        // this.$layer.alert({ msg: response.data.resultVal[0].display });
        if (response.data.resultVal[0].code.split('.')[2] === '0') {
          EventBus.$emit('toast', { type: 'success', content: response.data.resultVal[0].display });
          this.$refs[closePage].clear();
          this.$refs[closePage].close();
          this.getGridData(this.node);
        } else {
          EventBus.$emit('toast', { type: 'warning', content: response.data.resultVal[0].display });
        }
      } else {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.resultReturnFailedTip') });
      }
    },

    /**
     * 打开/关闭/保存  修改群组页面
     */
    openModImsGroupPage(opCode) {
      let groupid = false;
      if (opCode === 'mod') {
        groupid = this.getCheckedValsWithType(false, false);
      } else if (opCode === 'batchMod') {
        groupid = this.getCheckedValsWithType(true, 'grptype');
      }
      if (groupid) {
        this.opCode = opCode;
        this.groupnumList = groupid;
        const param = { msgid: this.taskMsgid.modGroupMsgid, neid: this.info.neid };
        // const param = { msgid: 56896, neid: this.info.neid };
        this.$axios.post('/lte/ems/subscriber/imsunms/getParamJson', param).then((response) => {
          if (response.status !== 200) {
            this.$refs.modGroupPage.clear();
            this.$refs.modGroupPage.close();
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
          } else {
            console.log(this.getParamsForNewPage(opCode));
            if (response.data.errorCode === '0') {
              this.batchModRes = response;
              if (this.info.neversion.includes(this.POC_VERSION_22) && opCode === 'mod') {
                //2.2 获取单个组服务信息
                this.querySingleTgrpServiceInfo(this.$refs.grid.getSelectedRecords(), opCode, response);
              } else if(this.info.neversion.includes(this.POC_VERSION_22) && opCode === 'batchMod') {
                // this.queryAllTgrpService([], (grpprofileInfoArr) => {
                //   groupid.forEach(item => {
                //    //匹配获取优先级和权限-------所有组服务信息中的信息
                //     const temp = grpprofileInfoArr.filter((sitem) =>
                //       item.grpnum === sitem.grpprofileid
                //     );
                //     for(let key in temp[0]) {
                //       item[key] = temp[0][key];
                //     }
                //   });
                  this.$refs.modGroup.mainHandler(groupid, this.getParamsForNewPage(opCode), response);
                  this.$refs.modGroupPage.show();
                // });
              }
              else {
                //2.3的修改页面
                this.$refs.modGroup.mainHandler(this.$refs.grid.getSelectedRecords(), this.getParamsForNewPage(opCode), response);
                this.$refs.modGroupPage.show();
              }
            } else {
              this.$refs.modGroupPage.clear();
              this.$refs.modGroupPage.close();
              EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            }
          }
        });
      }
    },

    /**
     *  查询单个群组服务
     *  data---一条记录
     *  opCode---修改或批量修改
     *  responseParamJson------修改页面
     **/
    querySingleTgrpServiceInfo(data, opCode, responseParamJson) {
      const group = data[0];//组号码
      const param = {
        page: { pageNo: 1, pageSize: 20},
        vo:{ flag: 1, grpprofileid: group.tgrpprofileid},
        info: { neid: this.info.neid, msgid: this.taskMsgid.qryGrpServiceMsgid}
      };
      // 需要拼装vo info
      this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
        if (response.data.errorCode !== '0') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        } else {
          const res = response.data.resultVal;
          const result = res.resultList;
          const resultIndexValue = result[0];
          for(const key in resultIndexValue) {
            group[key] = resultIndexValue[key];
          }
          console.log(group, data);
          group['grpidentity[grpidentity]'] = group['grpidentity'];
          this.$refs.modGroup.mainHandler(data, this.getParamsForNewPage(opCode), responseParamJson);
          this.$refs.modGroupPage.show();
        }
      });

    },
    async queryAllTgrpService(resultTotal, callFun) {
      // this.queryAllTgrpServiceInfo(this.$refs.grpPager.ej2Instances.currentPage, resultTotal, callFun);
      this.queryAllTgrpServiceInfo(1, resultTotal, callFun);
    },
    /**
     *  查询所有群组服务
     *  opCode---修改或批量修改
     *  responseParamJson------修改页面
     **/
    async queryAllTgrpServiceInfo(pageNo = 1, resultTotal = [], callFun) {
      const param = {
        page: { pageNo: pageNo, pageSize: 100},
        vo:{ flag: 0},
        info: { neid: this.info.neid, msgid: this.taskMsgid.qryGrpServiceMsgid}
      };
      // 需要拼装vo info
      this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
        if (response.data.errorCode !== '0') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        } else {
          const res = response.data.resultVal;
          const result = res.resultList;
          resultTotal = resultTotal.concat(result);
          // console.log("=======================",resultTotal);
          //数据量超100，则继续查询。。。。。。坑啊
          if (result && res.countrsp > 100 && res.count === 100) {
            this.queryAllTgrpServiceInfo(pageNo+1, resultTotal, callFun);
          } else {
            // return resultTotal;
            if (resultTotal.length === res.countrsp) {
              callFun(resultTotal);
            }
          }
        }
      });
    },
    closeModImsGroupPage() {
      this.$refs.modGroup.clearTemplate();
      this.$refs.modGroupPage.clear();
      this.$refs.modGroupPage.close();
    },
    saveModImsGroupPage() {
      const paramMap = {};
      this.info.msgid = this.taskMsgid.modGroupMsgid;
      paramMap.info = this.info;
      console.log('mod group param info=', this.info);
      let vodata = this.$refs.modGroup.getDatas();
      if (!vodata) {
        return;
      }
      vodata.vpnid = this.$refs.modGroup.info.vpnid;
      // vodata.tgrpprofileid = vodata.grpnum;
      if(vodata['grpidentity']) {
        vodata['grpidentity'] = vodata['grpidentity[grpidentity]'];
      }
      vodata = this.checkVpnid(vodata);
      if (this.opCode === 'batchMod') {
        this.$loading.showLoadding(this.$t('SubscriberIms.batchModUserTip'), this.$t('SubscriberIms.waitTip'));
        const grpprofileInfoFlag = this.$refs.modGroup.checkboxMap['grpprofileInfo'];
        const grppAdditionInfoFlag = this.$refs.modGroup.checkboxMap['grpAdditionInfo'];
        this.$refs.dialogList.setTotalCount(this.groupnumList.length);
        // 组数据赋值
        const grouplist = this.$refs.grid.getSelectedRecords();
        const batchParam = new Map();
        this.batchModRes.data.resultVal.forEach(item => {
          // if (item.couldBatchMod === true) {
          //   batchParam.set(item.name, true);
          // }
          // console.log(item.couldBatchMod, item.groupBy, this.$refs.modGroup.checkboxMap[item.name]);
          if (item.couldBatchMod && ((item.groupBy === 'grpprofileInfo' && grpprofileInfoFlag)
            || (item.name !== 'vpnid' && item.groupBy === undefined && this.$refs.modGroup.checkboxMap[item.name])
            || (item.name === 'vpnid' && vodata.vpnid !== null && item.groupBy === undefined && this.$refs.modGroup.checkboxMap[item.name])
            || (item.groupBy === 'grpAdditionInfo' && grppAdditionInfoFlag))) {
            batchParam.set(item.name, true);
          }
        });
        console.log('batchParam=', batchParam);
        this.$refs.modGroupPage.clear();
        this.$refs.modGroupPage.close();
        const logParam = {
          module: this.logParamInfo.module, // iMS群组管理
          execFunName: this.logParamInfo.execFunName[1], // 修改组
          exectype: 2,
          execData: [grouplist],
        };
        const paramBatch = {
          vo: {
            0: {
              vo: grouplist,
              info: {msgid: this.taskMsgid.modGroupMsgid, neid: this.info.neid}
            }
          },
          info: {operation: 'bacthOperate'},
          log: logParam
        };
        //2.2获取所有组服务信息，再与grouplist匹配获取优先级和权限
        // const grpprofileInfoArr = [];
        const _showData = [];
        if (this.info.neversion.includes(this.POC_VERSION_22)) {
          this.poc22Flag = true;
        } else{
          this.poc22Flag = false;
        }
        if (!grpprofileInfoFlag && this.poc22Flag) { //批量修改时，不修改优先级和权限
          this.queryAllTgrpService([], (grpprofileInfoArr)=>{
            console.log("grpprofileInfoArr.length=", grpprofileInfoArr.length);
            grouplist.forEach(item => {
             //匹配获取优先级和权限-------所有组服务信息中的信息
              const temp = grpprofileInfoArr.filter((sitem) =>
                item.grpnum === sitem.grpprofileid
              );
              for(let key in temp[0]) {
                item[key] = temp[0][key];
              }
              item.tgrpprofileid = item.grpnum;
              item.opCount = 1;
              const showData = {};
              showData.operObj = item.grpnum;
              _showData.push(showData);
              batchParam.forEach((value, paramItem) => {
                if (value) {
                  item[paramItem] = vodata[paramItem];
                }
              });
            });
            this.saveModBatch(paramBatch, _showData);
          } );
        } else {
          grouplist.forEach(item => {
            item.tgrpprofileid = item.grpnum;
            item.opCount = 1;
            const showData = {};
            showData.operObj = item.grpnum;
            _showData.push(showData);
            batchParam.forEach((value, paramItem) => {
              if (value) {
                item[paramItem] = vodata[paramItem];
              }
            });
          });
          this.saveModBatch(paramBatch, _showData);
        }
      } else if (this.opCode === 'mod') {
        vodata.opCount = this.groupnumList.length;
        vodata.tgrpprofileid = vodata.grpnum;
        paramMap.vo = vodata;
        const logParam = {
          module: this.logParamInfo.module, // iMS群组管理
          execFunName: this.logParamInfo.execFunName[1], // 修改组
          exectype: 2,
          execData: [vodata],
        };
        paramMap.log = logParam;
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramMap).then((response) => {
          if (response.status === 200) {
            this.commonHandlerResponse(response, 'modGroupPage');
            // this.$refs.modGroupPage.close();
            // this.$layer.alert({ msg: response.data.resultVal[0].display });
          } else {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip')});
          }
        });
      }
    },
    //批量修改通用功能
    saveModBatch(paramBatch, _showData) {
      this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramBatch).then((response) => {
        this.$loading.hideLoadding();
        if (response.status === 200) {
          this.$refs.dialogListPage.show();
          response.data.resultVal.forEach((item, index) => {
            _showData[index].operResult = item.display;
            _showData[index].operCode = item.code;
          });
          this.$refs.dialogList.addOperetionResultList(_showData);
          this.getGridData(this.node);
        } else {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.requestResTip')});
        }
      });
    },

    /**
     * 删除群组
     */
    delImsGroups() {
      const groupid = this.getCheckedValsWithType(true, false);
      if (groupid) {
        this.$layer.confirm({
          title:this.$t('SubscriberIms.reminder'),
          msg: this.$t('SubscriberIms.deleteConfirm'),
          btn1: {
            msg: this.$t('SubscriberIms.cancel')
          },
          btn2: {
            msg: this.$t('SubscriberIms.confirm'),
            func: () => {
              const paramMap = {};
              const grpnum = [];
              const resultObj = [];
              for (let i = 0; i < groupid.length; i++) {
                grpnum.push(groupid[i].grpnum);
                resultObj[i] = { operObj: groupid[i].grpnum };
              }
              paramMap.vo = { opCount: groupid.length, grpnum };
              this.info.msgid = this.taskMsgid.delGroupMsgid;
              paramMap.info = this.info;
              const logParam = {
                module: this.logParamInfo.module, // IMS群组管理
                execFunName: this.logParamInfo.execFunName[2], // 删除组数据
                exectype: 3,
                execData: resultObj,
              };
              paramMap.log = logParam;
              console.log('paramMap=', paramMap);
              this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', paramMap).then((response) => {
                if (response.data.resultVal) {
                  this.$refs.addGroupPage.clear();
                  this.$refs.addGroupPage.close();
                  this.$refs.dialogListPage.show();
                  response.data.resultVal.forEach((item, index) => {
                    resultObj[index].operResult = item.display;
                    resultObj[index].operCode = item.code;
                  });
                  this.$refs.dialogList.addOperetionResultList(resultObj);
                  this.getGridData(this.node);
                } else if (response.status !== 200) {
                  EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
                } else {
                  EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
                }
              });
            }
          }
        });
      }
    },

    /**
     * 打开/关闭/保存  添加组成员页面
     */
    openAddImsGroupMemberPage() {
      const groupid = this.getCheckedVals(true);
      if (groupid) {
        // 判断所选数据中是否有动态组---动态组不支持添加隶属关系
        const grppropertyList = groupid.filter((item) => item.grpproperty === 1);
        if (grppropertyList && grppropertyList.length > 0) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.dyGroupNotConfigLSGX') });
        } else {
          this.$refs.addGroupMemberPage.show();
          this.$refs.addGroupMember.mainHandler();
          this.$refs.addGroupMember.getGridData(this.node);
        }
      }
    },
    closeAddImsGroupMemberPage() {
      this.$refs.addGroupMemberPage.clear();
      this.$refs.addGroupMemberPage.close();
    },
    saveAddImsGroupMemberPage() {
      const groupSelecteds = this.$refs.grid.getSelectedRecords();
      // 拼写隶属关系数据
      const userList = this.$refs.addGroupMember.getCheckedData();
      let netgate = false;
      userList.forEach(item => {
        if(item.rtttype === 2 || item.rtttype === 5 || item.rtttype === 8){
          netgate = true;
        }
      });
      if(netgate === true){
        EventBus.$emit('toast', {type: 'warning', content: this.$t('SubscriberIms.notAddNetgate')});
        return;
      }
      if (userList.length === 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.chooseUserDataTip') });
      } else {
        this.$loading.showLoadding(this.$t('SubscriberIms.addUserMember'),this.$t('SubscriberIms.waitTip'));
        console.log(this.$refs.addGroupMember.$refs.memeberConfigInfo.getMemberInfo());
        const grpnum = [];
        const usrnum = [];
        const resultObj = [];
        groupSelecteds.forEach(item => {
          grpnum.push(item.grpnum);
        });
        userList.forEach(item => {
          const usrinfo = {};
          usrinfo.impu = item.impu;
          usrinfo.usertype = item.usertype;
          usrinfo.impugrppriority = item.impugrppriority;
          usrinfo.grpproperty = item.grpproperty;
          // const impugrpclass = item.impugrpclass_hidden.split(',');
          // const impugrpclass = item.impugrpclass_hidden;

          // usrinfo.impugrpclass = 0;
          // impugrpclass.forEach((bit, index) => {
          //   console.log(bit, index);
          //   if (bit === 1) {
          //     usrinfo.impugrpclass += Math.pow(2, index);
          //   }
          // });
          usrinfo.impugrpclass = item.impugrpclass;
          usrnum.push(usrinfo);
        });
        const param = {
          vo: { grpcount: grpnum.length, grpnums: grpnum, usercount: usrnum.length, resultList: usrnum },
          info: { neid: this.info.neid, msgid: this.taskMsgid.addGroupMemberMsgid }
        };
        let i = 0,
          j = 0;
        const grplen = grpnum.length;
        const impulen = usrnum.length;
        for (;i < grplen; i++) {
          for (;j < impulen; j++) {
            resultObj.push({ operObj: `${this.$t('SubscriberIms.groupNo')}${grpnum[i]}，${this.$t('SubscriberIms.userNo')}${usrnum[j].impu}` }); // 组号：xxx，用户号：xxx
          }
          j = 0;
        }
        const logParam = {
          module: this.logParamInfo.module, // IMS群组管理
          execFunName: this.logParamInfo.execFunName[3], // 添加隶属关系
          exectype: 1,
          execData: resultObj,
        };
        param.log = logParam;

        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
          if (response.data.resultVal && response.data.resultVal.length === 0) {
            this.$loading.hideLoadding();
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            return;
          }
          // this.$refs.addGroupMemberPage.clear();
          // this.$refs.addGroupMemberPage.close();
          this.$refs.dialogListPage.show();
          response.data.resultVal.forEach((item, index) => {
            resultObj[index].operResult = item.display;
            resultObj[index].operCode = item.code;
          });
          this.$loading.hideLoadding();
          this.$refs.dialogList.addOperetionResultList(resultObj);
        });
      }
    },
    /**
     * 打开/关闭/保存  组成员查询页面
     */
    openQryImsGroupMemberPage() {
      const groupid = this.getCheckedVals();
      if (groupid) {
        this.$refs.modGroupMemberPage.show();
        this.$refs.modGroupMember.getGridData(groupid[0].grpnum, true);
      }
    },
    closeModImsGroupMemberPage() {
      this.$refs.modGroupMemberPage.clear();
      this.$refs.modGroupMemberPage.close();
    },
    saveModImsGroupMemberPage() {
      console.log('==========');
    },

    /**
     * 打开/关闭/保存  添加用户页面
     */
    openQryGroupMemberPage() {
      const groupid = this.getCheckedVals();
      if (groupid) {
        this.$refs.addBlackListPage.show();
      }
      return null;
    },
    closeQryGroupMemberPage() {
      this.$refs.modGroupMemberPage.clear();
      this.$refs.modGroupMemberPage.close();
    },
    saveQryGroupMemberPage() {
      const groupid = this.getCheckedVals();
      if (groupid) {
        this.$refs.addBlackListPage.show();
      }
    },

    /**
     * 打开/关闭/保存  高级搜索页面
     */
    openSuperSearchPage() {
      this.$refs.superSearchPage.show();
      return null;
    },
    openLayerTipPage() {
      this.$refs.layerTip.show();
      return null;
    },
    closeLayerTipPage() {
      this.$refs.layerDialog.close();
    },
    closeDialogListTipPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close();
    },
    closenSuperSearchPage() {
      this.$refs.superSearchPage.show();
      return null;
    },
    saveSuperSearchPage() {
      this.$refs.superSearchPage.show();
      return null;
    },
    /**
     * 导入 导出
     */
    openImportGroupPage() {
      document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button').click();
      return false;
    },
    async onFileSelect(args) {
      if (args.filesData[0].type === 'xlsx' || args.filesData[0].type === 'xls') {
        if (this.isChooseNe() === false) {
          return;
        }
        const uploadFile = document.getElementById('file').files[0];
        this.$loading.showLoadding(this.$t('SubscriberIms.importdata'),this.$t('SubscriberIms.waitTip'));
        this.dataForm = [];//重新初始化
        await this.file2Xce(uploadFile).then(tabJson => {
          if (tabJson && tabJson.length > 0) {
            console.log(tabJson);
            const n = this.$t('SubscriberIms.grpNumTitle');
            console.log(n);
            tabJson[0].sheet.forEach((item, index, arr) => {
              console.log(index);
              this.dataForm[index] = item[n]; // 需要的值的表头
            });
            // console.log(JSON.stringify(this.dataForm));
          }
        });
        if (this.dataForm.length === 0) {
          this.$loading.hideLoadding();
          this.$refs.importGroup.clearAll();
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.noDataCanOper') });
          return;
        }
        // const uploadFile = document.getElementById('file').files[0];
        const formData = new FormData();
        const logParam = {
          module: 'res.subscriber#res.subscriber_ims#subscriber.imsGroup',
          execFunName:'subscriber.importgroup',
          exectype:1,
          //execData:[vodata]
        };
        formData.append('neid', this.info.neid);
        formData.append('operation', 'group');
        formData.append('file', uploadFile);
        formData.append('log',JSON.stringify(logParam));
        const config = {
          timeout: 1000 * 60 * 31,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        const _showDatas = [];
        this.dataForm.forEach((item) => {
          const showData = {};
          showData.operObj = item;
          _showDatas.push(showData);
        });
        console.log('grpnums=', _showDatas);
        // 下发任务
        this.$axios.post('/lte/ems/subscriber/imsunms/importData', formData, config).then((response) => {
          this.$refs.importGroup.clearAll();
          console.log(response);
          this.$loading.hideLoadding();
          if (response.status === 200) {
            if (response.data.resultVal && response.data.resultVal.length > 0) {
              this.$refs.dialogListPage.show();
              response.data.resultVal.forEach((item, index) => {
                _showDatas[index].operResult = item.display;
                _showDatas[index].operCode = item.code;
              });
              this.$refs.dialogList.addOperetionResultList(_showDatas);
              this.getGridData(this.node);
            } else {
              EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
            }
          } else {
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
          }
        });
      } else {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.impFileTypeErrTip') });
      }
    },
    file2Xce(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: 'binary'
          });
          const result = [];
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
            });
          });
          resolve(result);
        };
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file); // 传统input方法
      });
    },
    exportImsGroup(jsoninfo = []) {
      if (this.isChooseNe() === false) {
        return;
      }

      const qryParam = this.qrySearchBak ? this.qrySearchBak : { grpnum: '', grpname: '', grptype:-1, flag: 2 };

      const exportParam = {
        info: {
          neid: this.info.neid,
        },
        vo: {
          ...qryParam,
          vpnid: this.info.vpnid,
          vpnClass: this.info.vpnClass,
        },
        operation: 'group',
        log:{
          module: 'res.subscriber#res.subscriber_ims#subscriber.imsGroup',
          execFunName:'subscriber.exportgroup',
          exectype:1,
        },
      };

      const config = { responseType: 'blob' };

      this.$loading.showLoadding(this.$t('SubscriberIms.exportdata'),this.$t('SubscriberIms.waitTip'));
      this.$axios.post('/lte/ems/subscriber/imsunms/exportDataR', exportParam, config).then((res) => {
        const link = document.createElement('a');
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        const dateStr = new Date().Format('yyyy-MM-dd HH:mm');
        const fileName = `${this.$t('SubscriberIms.group')}_${dateStr}.xls`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$loading.hideLoadding();
      });
    },
    clearQryParam()
    {
      this.qrySearchBak = null;
    },
    /**
     * 组查询页面 打开、关闭
     */
    openQryImsGroupPage() {
      console.log('组查询条件');
      this.$refs.qryImsGroup.clearData();
      this.$refs.qryImsGroup.setData(this.qrySearchBak);
      this.$refs.qryImsGroupPage.show();
    },
    qryImsGroupPage() {
      console.log('组查询下发');
      const param = this.$refs.qryImsGroup.getFormValue();
      this.qrySearchBak = { ...param };
      this.getGridData(this.node);
      this.$refs.qryImsGroupPage.clear();
      this.$refs.qryImsGroupPage.close();
    },
    closeQryImsGroupPage() {
      this.$refs.qryImsGroupPage.clear();
      this.$refs.qryImsGroupPage.close();
    },
    checkNeStatus(callFun, opCode) {
      this.axios.get(`/lte/ems/config/mml/queryNodeLinkStatus/${this.info.neid}`).then(res => {
        const nodeStatus = res.data ? res.data.resultVal : 0;
        if (nodeStatus === 0) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Common.neOffLine', [this.node.neName]) });
        } else {
          callFun(opCode);
        }
    });
    }
    // readWorkbookFromRemoteFile() {
    //   let _this = this
    //   xhr.onload = function (e) {
    //     if (xhr.status === 200) {
    //       var data = new Uint8Array(xhr.response)
    //       var workbook = XLSX.read(data, {type: 'array'})
    //       console.log(workbook)
    //
    //       var sheetNames = workbook.SheetNames // 工作表名称集合
    //       _this.workbook = workbook
    //       _this.card = sheetNames
    //       _this.cardActive = sheetNames[0]
    //       _this.getTable(sheetNames[0])
    //     }
    //   }
    //   xhr.send();
    // },
    // getTable(sheetName) {
    //   console.log(111111111111)
    //   console.log(sheetName)
    //   var worksheet = this.workbook.Sheets[sheetName]
    //   this.tableData = XLSX.utils.sheet_to_json(worksheet)
    //   console.log(this.tableData)
    // }
  },
};
</script>

<style scoped>

</style>
